import { inject, injectable } from 'tsyringe';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { LoggerService } from '../../logger.service';
import {
  kDITOWUtilsWrapper,
  kDITOWWrapper,
} from '../../../constants/injectionTokens';
import { IOWWrapper } from '../../../interfaces/ow-wrappers/ow-wrapper.interface';
import { RecommendationDatastoreService } from '../../datastore-service/recommendation-datastore.service';
import { IOWUtilsWrapper } from '../../../interfaces/ow-wrappers/ow-utils-wrapper.interface';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.AppSpecific)
export class ConditionHostApp implements ICondition {
  private readonly logger = LoggerService.getCategory('ConditionHostApp');

  // ---------------------------------------------------------------------------
  public constructor(
    @inject(kDITOWWrapper)
    private readonly owWrapper: IOWWrapper,
    private readonly datastoreService: RecommendationDatastoreService,
    @inject(kDITOWUtilsWrapper)
    private readonly owUtilsWrapper: IOWUtilsWrapper,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const { application } = context;

    const platform = this.owWrapper.getPlatform();

    if (platform === 'ow') {
      return [true, null];
    }

    const hostApps = await this.datastoreService.getHostApps();
    this.logger.info('hostApps', JSON.stringify(hostApps));

    const currentHostAppId = this.owWrapper.getHostAppUid();

    if (!hostApps?.[currentHostAppId]) {
      return [false, NoRecommendationsReasons.HostAppNotApproved];
    }

    const userPhasing = await this.owUtilsWrapper.getPersistentPhasedPercent();
    const hostAppConfig = hostApps[currentHostAppId];
    const hasHostAppConfig = hostAppConfig.find((app) => {
      return (
        app.id === application.uid && app.enabled && userPhasing <= app.phasing
      );
    });

    const reason = hasHostAppConfig
      ? null
      : NoRecommendationsReasons.HostAppNotApproved;

    return [hasHostAppConfig, reason];
  }
}
